import { render, staticRenderFns } from "./PlazaView.vue?vue&type=template&id=66f6fe9f"
import script from "./PlazaView.vue?vue&type=script&lang=js"
export * from "./PlazaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports